export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar.vue?vue&type=template&id=e3f7a4b6&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/topbar.vue?vue&type=template&id=e3f7a4b6&scoped=true
// module id = AY2g
// module chunks = 0